import { render, staticRenderFns } from "./TwitterConnect.vue?vue&type=template&id=e8bb01d4&scoped=true"
import script from "./TwitterConnect.vue?vue&type=script&lang=js"
export * from "./TwitterConnect.vue?vue&type=script&lang=js"
import style0 from "./TwitterConnect.vue?vue&type=style&index=0&id=e8bb01d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8bb01d4",
  null
  
)

export default component.exports